<template>
  <v-toolbar-items>
    <v-menu offset-y>
      <template v-slot:activator="{on}">
        <v-btn
          text
          v-on="on"
          class="black--text langSwitcher">
          <v-icon left>mdi-translate</v-icon>
          <span>{{ getLanguage }}</span>
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(index, locale) in langDict"
          :key="index"
          @click="setLanguage(locale)"
          class="black--text"
        >
          <span>{{ langDict[locale] }}</span>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-toolbar-items>
</template>

<script>
export default {
  name: "LangSwitcher",
  data() {
    return {
      langDict: {
        en: "English",
        np: "नेपाली"
      }
    };
  },
  computed: {
    getLanguage: function() {
      return this.$i18n.locale;
    }
  },
  methods: {
    setLanguage: function(locale) {
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale;
        this.$router.push({ params: { lang: locale } });
      }
    }
  }
};
</script>

<style scoped>
.v-btn.v-size--default {
    font-size: 1em !important;
}
</style>
